import useId from '../utils/useId';
import * as React from 'react';
export const NPSvg = React.forwardRef(function NPSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement('path', {
        id: `fi_FlagIcon-NP__a_${id_0}`,
        d: 'M2 12a2 2 0 0 1-2-2V2A2 2 0 0 1 1.514.06L9.22 5.454A.3.3 0 0 1 9.048 6H4.545l4.999 5.498a.3.3 0 0 1-.222.502H2Z',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M2 0h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'M14 12H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Zm1-10a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2Z',
      }),
      /*#__PURE__*/ React.createElement('use', {
        fill: '#E25950',
        fillRule: 'evenodd',
        xlinkHref: '#fi_FlagIcon-NP__a',
      }),
      /*#__PURE__*/ React.createElement('path', {
        stroke: '#43458B',
        d: 'm8.87 11.5-5.455-6h4.999L1.43.612C.878.838.5 1.382.5 2v8A1.5 1.5 0 0 0 2 11.5h6.87Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M3 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-.5-5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1z',
      }),
    ),
  );
});
NPSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var NP = {
  category: 'flag',
  colorable: false,
  name: 'NP',
  svg: NPSvg,
};
